import React, { useEffect, useState } from "react";
import db from "../../../db"

// reactstrap components
import {
    Button,
    Input,
    Media,
    Row,
    Col,
    Form,
    FormGroup,
    Card,
} from "reactstrap";

// core components
import ImageUpload from "../../UploadImages/ImageUpload"
import DragDrop from "../../UploadImages/DragDrop"
import { handleUpload } from "../../UploadImages/HandleUpload"

function ClientForm({ selectedCategory, setSelectedCategory, flag, deleted, setDeleted }) {

    // Object Properties
    const [partnerId, setPartnerId] = useState("")
    const [caption, setCaption] = useState("")
    const [img, setImg] = useState([])
    const [website, setWebsite] = useState("")

    // For Upload
    // Progress bar
    const [progress, setProgress] = useState(0)


    const upload = async (taskFunction, task) => {
        let docRef = ""
        if (task === "create") {
            // If creating, create a new ID from firestore
            docRef = await db.OurPartners.createRef().id
        }
        else {
            docRef = partnerId
        }
        // Change directory to where you want to save it
        const directory = `ourpartners/${docRef}/${website}`
        handleUpload({ pictures: img, setProgress, docRef, taskFunction, task, directory })
    }

    const create = ({ urls, docRef }) => {
        // img: urls[0] means it will only take 1 image
        db.OurPartners.update({ id: docRef, caption, img: urls[0], website })
        reset()
    }

    const edit = async ({ urls }) => {
        const convert = { img: deleted }
        deleted.length > 0 && await db.OurPartners.removeOneImage(convert)
        // img: urls[0] means it will only take 1 image
        db.OurPartners.update({ id: partnerId, caption, img: urls[0], website })
        reset()
    }

    const reset = () => {
        setPartnerId("")
        setCaption("")
        setImg([])
        setWebsite("")
        setProgress(0)
        setSelectedCategory(null)
        setDeleted([])
    }

    // Set Input values to Selected Event's data
    useEffect(() => {
        if (selectedCategory) {
            setPartnerId(selectedCategory.id)
            setCaption(selectedCategory.caption)
            setImg([selectedCategory.img])
            setWebsite(selectedCategory.website)
        }
    }, [selectedCategory, flag])

    // Validation
    const valid = () =>
        caption &&
        img.length > 0 &&
        website

    const validEdit = () =>
        !valid()

    return (
        <div id="editPartner">
            <Card className="section-dark-blue">
                <Media style={{ padding: "2%" }}>
                    <Form className="form" style={{ minWidth: "100%", minHeight: "100%" }}>
                        <Media body>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        {/* You only need this one */}
                                        <ImageUpload
                                            pictures={img}
                                            progress={progress}
                                            maxNumber={1}
                                            setPictures={setImg}
                                            deleted={deleted}
                                            setDeleted={setDeleted}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                {/* This is for drag and drop - optional */}
                                <Col md="12" >
                                    {
                                        img.length === 0 &&
                                        <FormGroup>
                                            <DragDrop setPictures={setImg} />
                                        </FormGroup>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Input
                                            className="border-input"
                                            placeholder="Caption"
                                            type="text"
                                            onChange={(event) => setCaption(`${event.target.value}`)}
                                            value={caption}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Input
                                            className="border-input"
                                            placeholder="Website"
                                            type="text"
                                            onChange={(event) => setWebsite(event.target.value)}
                                            value={website || ""}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <div className="media-footer">
                                <Row>
                                    <Col lg="8" xs="6" md="8">
                                        {
                                            !partnerId ?
                                                <Button
                                                    className="btn-round mr-1"
                                                    color="success"
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        upload(create, "create")
                                                    }}
                                                    disabled={!valid()}
                                                    style={{ minWidth: "100%" }}
                                                >
                                                    Create
                                            </Button>
                                                :
                                                <Button
                                                    className="btn-round mr-1"
                                                    color="success"
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        upload(edit, "edit")
                                                    }}
                                                    disabled={validEdit()}
                                                    style={{ minWidth: "100%" }}
                                                >
                                                    Edit
                                            </Button>
                                        }
                                    </Col>
                                    <Col lg="4" xs="6" md="4">
                                        <Button
                                            className="btn-round mr-1"
                                            color="danger"
                                            type="button"
                                            onClick={reset}
                                            style={{ minWidth: "100%" }}
                                        >
                                            Cancel
                                    </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Media>
                    </Form>
                </Media>
            </Card>
        </div>
    );
}

export default ClientForm;
